import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import webView from 'common/webView';
import Card from 'components/_core/Card';
import Heading from 'components/_core/Heading';
import SunshineIcon from 'components/_core/SunshineIcon';
import Text from 'components/_core/Text';
import Skeleton from 'components/Skeleton';

import { locales } from './locales';

interface RevenueHeaderProps {
  transactionsSumLoading?: boolean;
  revenue: string;
  isSubjectToVat: boolean;
  focusVatAmount?: boolean;
  revenueWithoutVat: string;
}

const RevenueHeader: FC<RevenueHeaderProps> = ({
  focusVatAmount = false,
  isSubjectToVat,
  revenue,
  revenueWithoutVat,
  transactionsSumLoading = false,
}) => {
  const { isInWebView } = webView;

  return (
    <Card
      alignItems="center"
      border={isInWebView ? 'none' : undefined}
      display="flex"
      flexDirection="row"
      marginBottom="space-24"
      padding={isInWebView ? 'none' : undefined}
    >
      <Box flex={1}>
        <Skeleton isLoaded={!transactionsSumLoading}>
          <Text size="xs" variant={focusVatAmount ? 'light' : 'primary'}>
            {locales.revenue}
          </Text>
          <Heading
            color={focusVatAmount ? 'grey.600' : undefined}
            display="inline"
            size={isInWebView ? 'sm' : 'xl'}
            variant="number"
          >
            {revenue}
          </Heading>

          <Heading
            color={focusVatAmount ? 'grey.600' : undefined}
            display="inline"
            paddingLeft="space-4"
            size="sm"
            variant="number"
          >
            {locales.includingVAT}
          </Heading>
        </Skeleton>
      </Box>

      {isSubjectToVat ? (
        <SunshineIcon
          borderColor="grey.300"
          borderRadius="100%"
          borderWidth="1px"
          boxSizing="content-box"
          marginX={isInWebView ? 'space-8' : 'space-16'}
          name="arrow-right"
          padding="space-6"
          size="icon-20"
        />
      ) : null}

      {isSubjectToVat ? (
        <Box flex={1}>
          <Skeleton isLoaded={!transactionsSumLoading}>
            <Text size="xs" variant={focusVatAmount ? undefined : 'light'}>
              {locales.withoutVat}
            </Text>
            <Heading
              color={focusVatAmount ? undefined : 'grey.600'}
              display="inline"
              size={isInWebView ? 'sm' : 'xl'}
              variant="number"
            >
              {revenueWithoutVat}
            </Heading>

            <Heading
              color={focusVatAmount ? undefined : 'grey.600'}
              display="inline"
              paddingLeft="space-4"
              size="sm"
              variant="number"
            >
              {locales.excludingVAT}
            </Heading>
          </Skeleton>
        </Box>
      ) : null}
    </Card>
  );
};

export default RevenueHeader;
